import AutoScroll from 'embla-carousel-auto-scroll';
import useEmblaCarousel, { UseEmblaCarouselType } from 'embla-carousel-react';

import { useCallback, useEffect, useState } from 'react';

/* TODO:
 * futuramente, criar um componente abstrato neste arquivo (Composite) para montagem de carrousel.
 * (embla, embla__container, embla__viewport, embla__next, embla__prev) etc...
 */
const usePrevNextButtons = (emblaCarousel: UseEmblaCarouselType) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);
  const [_, emblaApi] = emblaCarousel;

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((api: typeof emblaApi) => {
    if (!api) return;
    setPrevBtnDisabled(!api.canScrollPrev());
    setNextBtnDisabled(!api.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect(emblaApi);
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
    return () => {
      emblaApi.off('select', onSelect);
      emblaApi.off('reInit', onSelect);
    };
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

export { useEmblaCarousel, usePrevNextButtons, AutoScroll };
